import type { SceneGroup } from '@lumen5/luminary';

import { setSceneOverrides } from 'js/src/data/user-overrides/user-overrides-actions';
import { getUserOverrides } from 'js/src/data/user-overrides/user-overrides-selectors';
import type { AppDispatch } from 'js/src/libs/RootState';
import type { GetRootState } from 'js/src/luminary/luminary-redux-connect-types';

/**
 * When we duplicate a scene group we want to duplicate over any user overrides for any scenes in the scene group
 * to ensure we don't make undesired changes.
 */
export const copyUserOverridesForDuplicatedSceneGroup = (
    newSceneGroup: SceneGroup,
    sourceSceneGroup: SceneGroup,
    systemTriggered: boolean,
    parentActionGroup: string | undefined,
) => {
    return (dispatch: AppDispatch, getState: GetRootState) => {
        const newSceneIds = newSceneGroup.scenes.map((scene) => scene.id);
        const sourceSceneIds = sourceSceneGroup.scenes.map((scene) => scene.id);
        if (newSceneIds.length === 0 || sourceSceneIds.length === 0) {
            return;
        }
        if (newSceneIds.length !== sourceSceneIds.length) {
            throw new Error('Scene group length mismatch');
        }

        const userOverrides = getUserOverrides(getState());
        if (!userOverrides) {
            return;
        }

        // Copy over the overrides for the scenes in the new scene group
        Object.keys(userOverrides).forEach((sceneId) => {
            if (sourceSceneIds.includes(sceneId)) {
                const newSceneId = newSceneIds[sourceSceneIds.indexOf(sceneId)]; // get corresponding new scene id
                dispatch(
                    setSceneOverrides({
                        sceneId: newSceneId,
                        overrides: userOverrides[sceneId],
                        systemTriggered,
                        parentActionGroup,
                    }),
                );
            }
        });
    };
};
